import React from "react";
import "antd/dist/antd.less";
import "./styles/main.less";
import 'react-toastify/dist/ReactToastify.css';
import AppLayout from "./containers/layout";
import { AuthProvider } from "./contexts/auth/AuthContext";
import { ConfigProvider } from "antd";
import moment from "moment";
import ru_RU from "antd/lib/locale/ru_RU";
import en_US from "antd/lib/locale/en_US";
import "moment/locale/ru";
import "./styles/Dark.css"
import i18n from "./services/i18n";
import { ConfigProviderProps } from "antd/lib/config-provider";
import { ToastContainer } from 'react-toastify';
import {ThemeProvider} from "./contexts/ThemeContex";
import ErrorBoundary from "./components/ErrorBoundary";

const validateMessages = {
  // eslint-disable-next-line no-template-curly-in-string
  required: `'${i18n.t("requiredField")} - \${label}'`,
};

/**
 * Tanlangan til: kalendar, sahifalash va "ma'lumot yo'q" kabi yozuvlar
 * antd kutubxonasidan keladi va ilgari ruschaga qotirib qo'yilgan edi —
 * shuning uchun til almashtirilganda ular ruscha qolib ketardi.
 * antd 4.22 da o'zbek tili yo'q, shuning uchun o'zbekchada inglizcha
 * kalendar ishlatiladi (ruscha emas).
 */
const uiLang = (i18n.language || "ru").split("-")[0];
const antdLocale = uiLang === "ru" ? ru_RU : en_US;
moment.locale(uiLang === "ru" ? "ru" : "en");

const antdConfig: ConfigProviderProps = {
  locale: antdLocale,
  form: { validateMessages },
};

function App() {
  return (
    <ConfigProvider {...antdConfig}>
      <ErrorBoundary>
        <AuthProvider>
          <ThemeProvider>
            <AppLayout />
            <ToastContainer position="bottom-right"/>
          </ThemeProvider>
        </AuthProvider>
      </ErrorBoundary>
    </ConfigProvider>
  );
}

export default App;
